module.exports = __webpack_public_path__ + "static/media/close.4164cabf.svg";